"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const convertBallsTotalToOvers = (props) => {
    if (!props.ballsPerOver)
        props.ballsPerOver = 6;
    if (props.balls === 0)
        return props.balls;
    let overs = Number(props.balls / props.ballsPerOver).toString();
    if (overs.search(/\./) > -1) {
        overs = overs.split('.');
        overs[1] = Number('.' + lodash_1.round(overs[1], 3));
        overs = overs[0] + '.' + lodash_1.round(props.ballsPerOver * overs[1]);
    }
    return Number(overs);
};
exports.default = convertBallsTotalToOvers;
//# sourceMappingURL=convertBallsTotalToOvers.js.map